import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ChangeControlDisplayDetails } from './models/change-control-display-details';
import { ChangeControlDetailsService } from './services/change-control-details.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { Router } from '@angular/router';
import { ChangeControlConstants } from './constants/changeControlConstants';
import { catchError, throwError } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ChangeManagementConstant } from './constants/changeManagementConstants';
import { AuthenticationHelperService } from '../../shared/components/authentication-maintainance/services/authentication-helper.service';
import { ActionItemDetails } from './models/action-item-details';
import { ChangeControlPersistenceService } from './services/change-control-persistence.service';
import { ChangecontrolPersistenceService } from '../change-control-library/services/changecontrol-persistence.service';

@Component({
  selector: 'app-change-control-details',
  templateUrl: './change-control-details.component.html',
  styleUrls: ['./change-control-details.component.scss'],
})
export class ChangeControlDetailsComponent implements OnInit {
  activeIndex: number = 0;
  changeControlDisplayDetails: ChangeControlDisplayDetails =
    {} as ChangeControlDisplayDetails;
  changeControlNumber: string = '';
  topBarTitle: string = ChangeControlConstants.ChangeControlDetailsTitle;
  isReasonForChangeModal: boolean = false;
  pageLoadErrorMessage: string = '';
  isChangeControlDetailsAccessible: boolean = false;
  isChangeControlSliderOpen: boolean = false;
  isTransactionModal:boolean = false;
  selectedActionItem: any;
  previousPhaseModalHeader: string = ChangeManagementConstant.PreviousPhase_ReasonForChange_Header;
  changeControlLoader: boolean = false;
  showCCVoidReasonPopUp:boolean=false;
  validationMessageForReasonForMovingCCToVoided:string= ChangeManagementConstant.Reason_Validation_Text;
  headingForMoveCCToVoidedPhase:string = ChangeManagementConstant.ChangeControlMoveToVoidReason_HeaderText;

  constructor(
    private changeControlDetailsService: ChangeControlDetailsService,
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private readonly authenticationHelperService: AuthenticationHelperService,
    private readonly changeControlPersistenceService: ChangeControlPersistenceService,
    private readonly changeControlLibraryPersistenceService : ChangecontrolPersistenceService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    let url = this.router.url;
    if (url.includes('/eqms.changeControlDetails/')) {
      this.changeControlNumber = url.substring(
        url.lastIndexOf('/') + 1,
        url.length
      );
    }
    this.intialize();
    this.changeControlLibraryPersistenceService.toastMessage$
    .subscribe(message => {
      this.messageService.add(message);
    });
    this.changeControlLibraryPersistenceService.dataReload$.subscribe((reload)=>{
      if(reload){
        setTimeout(() => {    
          this.intialize();
        }, 3000);
      }
    })
    
  }

  intialize = () => {
    this.loadChangeControlDetails();
  };

  loadChangeControlDetails = () => {
    this.changeControlDetailsService
      .getChangeControlDetails(this.changeControlNumber)
      .subscribe({
        next: (serviceData) =>{ (this.changeControlDisplayDetails = serviceData)
          this.changeControlLibraryPersistenceService.changeManagementDisplayDetails$.next(this.changeControlDisplayDetails);
          this.changeControlPersistenceService.currentPhaseOfChangeControl= this.changeControlDisplayDetails.phase;
        },
        error: (err) => {
          if (err.status === LabelConstants.NotFound_StatusCode) {
            if (err.error && err.error.type) {
              this.pageLoadErrorMessage = err.error.type;
            }
          }
          if (err.status === LabelConstants.Forbidden_StatusCode) {
            if (err.error && err.error.detail) {
              this.pageLoadErrorMessage = err.error.detail;
            }
          }
        },
        complete: () => {
          if(this.changeControlDisplayDetails?.phase == ChangeControlConstants.ChangeControl_Verification_PhaseNumber || this.changeControlDisplayDetails?.phaseValue == ChangeControlConstants.ChangeControl_Verification_PhaseName){
            this.ValidatePreviousPhase();
          }
          this.isChangeControlDetailsAccessible = true;
        },
      });
  };

  toggleLoader(value: boolean){
    this.changeControlLoader = value;
  }

  closeReasonForChangeModal(event: any) {
    this.isReasonForChangeModal = false;
  }

  displayReasonForChangeModalOnClick(event: boolean): void {
    this.isReasonForChangeModal = !this.isReasonForChangeModal;
  }

  UpdateChangeControlDetail(
    updatedChangeControlDisplayDetails: ChangeControlDisplayDetails
  ) {
    this.changeControlDisplayDetails = updatedChangeControlDisplayDetails;
    this.ValidatePreviousPhase();
  }

  moveToNextPhase = () => {
    this.changeControlDisplayDetails.phase ===
    Number(ChangeControlConstants.ChangeControl_Implementation_Phase)
      ? this.validateNextPhaseMovement()
      : this.confirmDialog();
  };

  confirmDialog() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.savePhaseChange();
      },
      reject: () => {},
    });
  }

  savePhaseChange = () => {
    this.changeControlDetailsService
      .moveToNextPhase(this.changeControlDisplayDetails.number)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: ChangeManagementConstant.Severity_Err,
            summary: `${err.error}`,
          });
          return throwError(() => err);
        })
      )
      .subscribe((serviceData) => {
        this.messageService.add({
          severity: ChangeManagementConstant.Severity_Info,
          summary: `${ChangeManagementConstant.MoveToNextPhase_Success}`,
        });
        this.changeDetectorRef.detectChanges();
        this.UpdateChangeControlDetail(serviceData);
        this.changeControlPersistenceService.actionPlanDataUpdated.next(true);
        this.changeControlPersistenceService.updateChangeControlView();
      });
  };

  openSlider(){
    this.isChangeControlSliderOpen = true;
  }

  closeChangeControlSlider(isSliderActive: boolean) {
    this.isChangeControlSliderOpen = isSliderActive;
  }
  
  openTransactionModal = () => {
    this.isTransactionModal = true;
  }

  closeTransactionModal = (event: boolean) => {
    this.isTransactionModal = false;
  }
  updateChangeControlDetailsOnTransaction =
    (event: ChangeControlDisplayDetails) => {
    this.UpdateChangeControlDetail(event);
    this.isTransactionModal = false;
  }

  getSelectedActionItems(data: ActionItemDetails[]){
    this.selectedActionItem = data;
    this.changeControlPersistenceService.updateSelectedActionitem(data);    
  }

  ValidatePreviousPhase(){
    if(this.changeControlDisplayDetails?.phase == ChangeControlConstants.ChangeControl_Verification_PhaseNumber 
        || this.changeControlDisplayDetails?.phaseValue == ChangeControlConstants.ChangeControl_Verification_PhaseName){
      this.changeControlPersistenceService.updatePreviousPhaseToolTip(ChangeControlConstants.ChangeControl_PreviousPhaseFromVerify_ToolTip);
      this.previousPhaseModalHeader = ChangeManagementConstant.PreviousPhase_ReasonForChangeInVerificationPhase_Header;
    }
    else{
      this.previousPhaseModalHeader = ChangeManagementConstant.PreviousPhase_ReasonForChange_Header; // resetting back the Input parameter for Previous Phase Modal Header
      this.changeControlPersistenceService.updatePreviousPhaseToolTip(ChangeControlConstants.ChangeControl_PreviousPhase_ToolTip);
    }
  }

  validateNextPhaseMovement(){
    this.changeControlDetailsService
      .validateNextPhaseMovementFromImplementation(this.changeControlDisplayDetails.number)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: ChangeManagementConstant.Severity_Err,
            summary: `${err.error}`,
          });
          return throwError(() => err);
        })
      )
      .subscribe(() => {
        this.confirmationService.confirm({
          message: ChangeControlConstants.ChangeControl_ConfirmationMessage,
          header: ChangeControlConstants.Confirmation_Header,
          icon: 'pi pi-exclamation-triangle',
          acceptIcon: 'pi pi-check',
          rejectIcon: 'pi pi-times',
          accept: () => {
            this.authenticationHelperService.reauth(
              this.savePhaseChange.bind(this),
              () => {}
            )
          },
          reject: () => {},
        });
      });
  }

  exportToPDF(): void {
    this.changeControlDetailsService.exportToPDF(this.changeControlNumber).subscribe({
      next: (response) => {
        const fileName = `${this.changeControlDisplayDetails.number} ${this.changeControlDisplayDetails.title} - Change Control Summary Report.pdf`;
        let byteData = response;
        const byteCharacters = atob (byteData);
        const byteNumbers = new Array (byteCharacters.length);
        for (let i = 0; i <byteCharacters.length; i ++) {
          byteNumbers [i] = byteCharacters.charCodeAt (i);
        }
        const byteArray = new Uint8Array (byteNumbers);
        let blob = new Blob ([byteArray], {type: 'application/pdf'});
        const url = window.URL.createObjectURL (blob);
        const anchor = document.createElement ('a');
        anchor.download = fileName;
        anchor.href = url;
        anchor.click ();
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Export Failed',
          detail: 'Unable to generate the PDF. Please try again later.',
        });
      },
    });
  }

  openReasonForVoidPopUp(){
    this.showCCVoidReasonPopUp=true;
  }

    moveCCToVoidedPhase(ccVoidReason: any) {
      this.showCCVoidReasonPopUp = false;

      this.changeControlDetailsService
        .moveChangeControlToVoided(
          this.changeControlDisplayDetails.number,
          ccVoidReason
        )
        .pipe(
          catchError((err) => {
            this.messageService.add({
              severity: ChangeManagementConstant.Severity_Err,
              summary:  ChangeManagementConstant.MoveToVoidedPhase_Failure
            });
            return throwError(() => err);
          })
        )
        .subscribe((serviceData) => {
          this.messageService.add({
            severity: ChangeManagementConstant.Severity_Info,
            summary: ChangeManagementConstant.MoveToVoidedPhase_Success,
          });

          this.changeDetectorRef.detectChanges();
          this.UpdateChangeControlDetail(serviceData);
          this.changeControlPersistenceService.updateChangeControlView();
          this.changeControlPersistenceService.actionPlanDataUpdated.next(true);

        });
      }
  closeReasonDailog(event:any){
 this.showCCVoidReasonPopUp=false;
  }
}
